import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';

import FormGroup from '../../../../../../../components/global/FormGroup';
import Alert from '../../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../../util/formik';
import Label from '../../../../../../../components/global/Label';
import DatePickerWithYearDropdown from '../../../../../../../components/global/DatePickerWithYearDropdown';
import InputGroup from '../../../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../../../util/assets';
import { EVENT_DETAILS_CONTEXT } from '../utils';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email_address: PropTypes.string,
  }),
  values: PropTypes.shape({
    name: PropTypes.string,
    start_date: PropTypes.object,
    end_date: PropTypes.object,
  }).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  context: PropTypes.oneOf(Object.values(EVENT_DETAILS_CONTEXT)),
};

const VacationEventDetails = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  context,
}) => {
  const errorList = Object.values(getFormikTouchedErrors(errors, touched));
  const { start_date: startDate, end_date: endDate } = values;

  return (
    <Fragment>
      <FormGroup
        id="name"
        name="name"
        error={!!errors.name}
        label={
          context === EVENT_DETAILS_CONTEXT.SLIDESHOW
            ? 'Slideshow Name'
            : 'Trip Name'
        }
        placeholder="Enter trip name here..."
        required
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.name}
      />
      <div className="row">
        <div className="col-lg-6 col-12">
          <div className="form-group">
            <Label id="start_date">Start date</Label>
            <div className="datepicker-gray-light">
              <DatePickerWithYearDropdown
                id="start_date"
                name="start_date"
                optional
                customInput={
                  <InputGroup
                    id="start_date"
                    name="start_date"
                    error={!!errors.start_date}
                    type="text"
                    autoComplete="off"
                    addon={
                      <img
                        alt=""
                        src={getAsset('/shutterbug/icons/calendar.svg')}
                      />
                    }
                  />
                }
                popperClassName="freemium-event-date-picker-popper"
                wrapperClassName="freemium-event-date-picker"
                onChange={selectedDate => {
                  handleChange({
                    target: {
                      name: 'date',
                      value: startOfDay(selectedDate),
                    },
                  });
                  handleChange({
                    target: {
                      name: 'start_date',
                      value: startOfDay(selectedDate),
                    },
                  });

                  if (startOfDay(selectedDate) > endDate) {
                    handleChange({
                      target: {
                        name: 'end_date',
                        value: null,
                      },
                    });
                  }
                }}
                selected={startDate}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="form-group">
            <Label id="end_date">End date</Label>
            <div className="datepicker-gray-light">
              <DatePickerWithYearDropdown
                id="end_date"
                name="end_date"
                optional
                customInput={
                  <InputGroup
                    id="end_date"
                    name="end_date"
                    error={!!errors.end_date}
                    type="text"
                    autoComplete="off"
                    addon={
                      <img
                        alt=""
                        src={getAsset('/shutterbug/icons/calendar.svg')}
                      />
                    }
                  />
                }
                popperClassName="freemium-event-date-picker-popper"
                wrapperClassName="freemium-event-date-picker"
                onChange={selectedDate => {
                  handleChange({
                    target: {
                      name: 'end_date',
                      value: endOfDay(selectedDate),
                    },
                  });
                }}
                selected={endDate}
                minDate={startDate}
              />
            </div>
          </div>
        </div>
      </div>

      {errorList.length > 0 && (
        <Alert type="danger" className="mt-1 text-normal">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

VacationEventDetails.propTypes = propTypes;

export default VacationEventDetails;
